import { render } from "./AddCash.vue?vue&type=template&id=af979ce0&ts=true"
import script from "./AddCash.vue?vue&type=script&lang=ts"
export * from "./AddCash.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__